import { useEffect, useState } from "react";

function UserForm() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  const fetchUsers = () => {
    fetch("/api/users")
      .then(res => res.json())
      .then(data => setUsers(data))
      .catch(err => "");
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch("/api/users", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    })
      .then(res => {
        if (!res.ok) throw new Error("Failed to add user");
        return res.json();
      })
      .then(() => {
        fetchUsers();
        setForm({ name: "", email: "", password: "" });
      })
      .catch(err => console.error(""));
  };

  return (
    <div className="container mt-5">
      {/* Title */}
      <h1 className="text-center mb-4">User Management</h1>

      {/* User List */}
      <div className="card shadow-sm mb-5">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Registered Users</h5>
        </div>
        <ul className="list-group list-group-flush">
          {users.length > 0 ? (
            users.map(u => (
              <li key={u.id} className="list-group-item">
                <strong>{u.name}</strong> <span className="text-muted">({u.email})</span>
              </li>
            ))
          ) : (
            <li className="list-group-item text-muted">No users found</li>
          )}
        </ul>
      </div>

      {/* Add User Form */}
      <div className="card shadow-sm">
        <div className="card-header bg-success text-white">
          <h5 className="mb-0">Add New User</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              name="password"
              className="form-control"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />
            <button type="submit" className="btn btn-success">
              Add User
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UserForm;
